import {
  OpenInNewRounded,
  PersonOutline,
  StoreOutlined,
  Tag,
} from "@mui/icons-material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import {
  amber,
  blue,
  brown,
  deepOrange,
  green,
  grey,
  lightBlue,
  lightGreen,
  orange,
  red,
} from "@mui/material/colors";
import { size } from "lodash";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import { getDaysAgo } from "../../../_src_shared/utils/functions/getDaysAgo";
import Flx from "../../layout/Flx";
import ChipItem from "../../ui/ChipItem";
import { Link } from "@mui/material";

const CellRendererLoanName = (params) => {
  const loanNumber = useMemo(() => {
    return params?.data?.loanNumber;
  }, [params?.data?.loanNumber]);

  const createdDateValue = useMemo(() => {
    const val = params?.data?.createDateTime;
    if (isNil(val)) {
      return "N/A";
    }
    const daysAgo = getDaysAgo(val);

    if (daysAgo === 0) {
      return "Created today";
    }
    if (daysAgo === 1) {
      return "Created 1 day ago";
    }

    return `${daysAgo} days old`;
  }, [params?.data?.createDateTime]);

  const updatedDateValue = useMemo(() => {
    const val = params?.data?.updateDateTime;
    if (isNil(val)) {
      return "N/A";
    }
    const daysAgo = getDaysAgo(val);

    if (daysAgo === 0) {
      return "Updated today";
    }
    if (daysAgo === 1) {
      return "Updated 1 day ago";
    }

    return `Updated ${daysAgo} days ago`;
  }, [params?.data?.updateDateTime]);

  return (
    <Flx column g={0.8} sx={{ py: 2 }}>
      <Flx ac gap={0.4}>
        <span style={{ lineHeight: 1 }}>{params?.value || "asd"}</span>
        <ChevronRight color="inherit" sx={{ opacity: 0.4, fontSize: "16px" }} />
      </Flx>
      <Flx gap={1}>
        <ChipItem
          color={"#2962ff"}
          backgroundColor={lightBlue[50]}
          backgroundHoverColor={blue[100]}
          icon={<Tag className="thin-8" />}
          customContent={
            <Link
              color={"primary"}
              sx={{
                display: "flex",
                alignItems: "center",
                lineHeight: 1.8,
                fontSize: "11px",
                textDecoration: "none",
              }}
              href={`${window.location.origin}/loan/${loanNumber}`}
              target="_blank"
              rel="noreferrer"
            >
              {loanNumber}
              <OpenInNewRounded
                sx={{
                  display: "block",
                  fontSize: "11px !important",
                  marginLeft: 1,
                  color: "#2962ff",
                }}
              />
            </Link>
          }
          value={loanNumber}
        />
        <LoanStatusChip loanStatus={params?.data?.loanStatus} />

        <ChipItem
          icon={<PersonOutline className="thin-8" />}
          value={`${size(params?.data?.borrowers)}`}
          // value={`Borrowers (${size(params?.data?.borrowers)})`}
        />
        <ChipItem
          icon={<StoreOutlined className="thin-8" />}
          value={`${size(params?.data?.subjectProperties)}`}
          // value={`Properties (${size(params?.data?.subjectProperties)})`}
        />
      </Flx>
    </Flx>
  );
};

const LoanStatusChip = ({ loanStatus }) => {
  const styles = useMemo(() => {
    // let textColor = grey[900];
    // let textColor = blue[900];
    // let textColor = lightBlue[900];
    // let backgroundColor = lightBlue[50];
    // let backgroundHoverColor = blue[100];
    let textColor = green[900];
    let backgroundColor = lightGreen[50];
    let backgroundHoverColor = lightGreen[100];

    if (loanStatus === "Prospect") {
      textColor = brown[900];
      backgroundColor = amber[50];
      backgroundHoverColor = amber[100];
    }

    if (["Inactive", "Dead"].includes(loanStatus)) {
      textColor = red[900];
      backgroundColor = red[50];
      backgroundHoverColor = red[100];
    }
    if (
      [
        "Closed",
        "Closed w/ Post Closing Conditions",
        "Balance Sheet",
        "Loan Sold",
      ].includes(loanStatus)
    ) {
      textColor = lightGreen[50];
      backgroundColor = lightGreen[700];
    }

    return {
      color: textColor,
      backgroundColor: backgroundColor,
      backgroundHoverColor: backgroundHoverColor,
    };
  }, [loanStatus]);
  return (
    <ChipItem
      // color={"#2962ff"}
      color={styles.color}
      backgroundColor={styles.backgroundColor}
      // backgroundHoverColor={styles.backgroundHoverColor}
      // icon={<Tag className="thin-8" />}
      // sx={getRowStyle}
      value={loanStatus}
    />
  );
};

export default CellRendererLoanName;
